import { Line } from 'vue-chartjs'
import ChartTooltip from './ChartTooltip'
import ChartLegends from './ChartLegends'

export default {
    name: 'line-chart',
    extends: Line,
    components: {
        'chart-tooltip': ChartTooltip,
        'chart-legends': ChartLegends,
    },

    watch: {
        chartdata: function(newValue, oldValue) {
            this.$data._chart.destroy()
            this.rerenderChart(this.chartdata, this.options)
        }
    },

    render: function (createElement) {
      return createElement(
        'div', {
          style: this.styles,
          class: 'chart-wrapper line-chart-wrapper pt-5',
          on: {
            mouseout: this.hideTooltip
          }
        },
        [
            createElement(
                'chart-legends', {
                    props: {
                        datasets: this.chartdata.datasets
                    }
                }
            ),
            createElement(
                'canvas', {
                    attrs: {
                        id: this.chartId,
                        width: this.width,
                        height: this.height
                    },
                    ref: 'canvas'
                }
            ),
            createElement(
                'chart-tooltip', {
                    props: {
                        tooltipModel: this.tooltipModel,
                        tooltipSettings: this.tooltipSettings,
                        datasetLabels: this.datasetLabels,
                        hasLegends: true
                    }
                }
            )
        ]
      )
    },

    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        },
        renderingOptions: {
            type: Array,
            default: null
        },
        tooltipSettings: {
            type: Object,
            default: null
        }
    },

    computed: {
        datasetLabels() {
            return this.chartdata.datasets.map((dataset) => {
                return dataset.label
            })
        },
        datasetColors() {
            return this.chartdata.datasets.map((dataset) => {
                return dataset.borderColor
            })
        },
        // cssClasses() {
        //     return 'chart-wrapper line-chart-wrapper pt-5'
        // }
    },

    data() {
        return {
            tooltipModel: null
        }
    },
    methods: {
        rerenderChart() {
            let area = this.$refs.canvas
            let context = area.getContext("2d")

            if (this.renderingOptions) {
                this.processFillOptions(context)
            }

            this.addCustomToolTip()

            this.renderChart(this.chartdata, this.options)
        },
        hideTooltip(event) {
            this.tooltipModel = null
        },
        toggleDataset(index) {

            if (this.chartdata.datasets[index].hidden === true) {
                this.chartdata.datasets[index].hidden = false
            } else {
                this.chartdata.datasets[index].hidden = true
            }

            this.$data._chart.update()
        },
        processFillOptions(context) {
            for (let option of this.renderingOptions) {
                let bgColor = option.backgroundColor

                if (typeof option.gradientize !== 'undefined' && option.gradientize) {
                    let gradient = context.createLinearGradient(0, 0, 0, 200)
                    gradient.addColorStop(0, option.backgroundColor)
                    gradient.addColorStop(1, 'rgba(255, 255, 255, 0.4)')
                    bgColor = gradient
                } else if (typeof option.gradient !== 'undefined' && option.gradient) {
                    let gradient = context.createLinearGradient(0, 0, 0, 200)
                    gradient.addColorStop(0, option.backgroundColor)
                    gradient.addColorStop(1, option.backgroundColorEnd)
                    bgColor = gradient
                }

                this.chartdata.datasets[option.index].fill = option.fillRule
                this.chartdata.datasets[option.index].backgroundColor = bgColor
            }
        },
        addCustomToolTip() {
            this.options.tooltips = {
                enabled: false,
                intersect: false,
                mode: 'label',
                custom: (tooltipModel) => this.processTooltipModel(tooltipModel)
            }
        },
        processTooltipModel(model) {
            if (model.title) {
                this.tooltipModel = model
            }
        }
    },
    mounted () {
        this.rerenderChart(this.chartdata, this.options)
    }
}
